import { format } from 'date-fns';
import * as R from 'ramda';

import { ReportOption } from '@atom/components/workOrderDetail/workOrderDetailHeader/reportOptions';
import {
  getTaskThreshold,
  getThresholdLabel,
  getTotalOtHours,
} from '@atom/components/workOrderDetailPdfReport/HidotWorkOrderPdfReport/HidotOvertimeReport/hidotOvertimeReportUtilities';
import { ReportTypes } from '@atom/types/preferences';
import { WorkOrderDetailType } from '@atom/types/work';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { setDisplayDate } from '@atom/utilities/timeUtilities';
import { getWorkOrderStatusType } from '@atom/utilities/workOrderStatusUtilities';

const REPORT_META_DATA: Partial<
  Record<ReportTypes, (workOrder: WorkOrderDetailType) => object>
> = {
  [ReportTypes.HIDOT_REPORT_OVERTIME]: workOrder => {
    const task = workOrder?.tasks?.[0];

    return {
      threshold: getThresholdLabel(getTaskThreshold(task)),
      totalOtHours: getTotalOtHours(task),
    };
  },
};

export const getWorkReportBody = (
  name: string,
  reportOption: ReportOption,
  workOrder: WorkOrderDetailType,
  includeInfoSection: boolean,
) => {
  const workOrderMetaData = {
    workOrderName: workOrder?.name,
    createdDate: setDisplayDate(workOrder?.createdDate),
    createdYear: format(workOrder?.createdDate, 'yyyy'),
    workStatus: getWorkOrderStatusType(workOrder?.statusId)?.label,
    createdByName: workOrder?.createdByName,
    completedYear: workOrder?.completionDate
      ? format(workOrder?.completionDate, 'yyyy')
      : '',
    completedDate: setDisplayDate(workOrder?.completionDate),
    dueDateYear: workOrder?.dueDate ? format(workOrder?.dueDate, 'yyyy') : '',
    closedByName: workOrder?.closedByName,
    workTemplateName: workOrder?.workTemplateName,
    inventoryAssetName: workOrder?.inventoryAssetName,
    categoryPathName: R.pathOr(
      'Unknown',
      ['assets', workOrder?.inventoryAssetId, 'categoryPath', 1, 'name'],
      workOrder,
    ),
    actualCost: numberToLocaleString(workOrder?.actualCost),
    ...(REPORT_META_DATA[reportOption?.value]?.(workOrder) || {}),
  };

  return {
    id: workOrder?.id,
    name,
    type: reportOption?.type,
    value: reportOption?.value,
    ...(reportOption?.displayEmptyAttributes && {
      displayEmptyAttributes: reportOption?.displayEmptyAttributes,
    }),
    ...(includeInfoSection && { includeInfoSection }),
    workOrderMetaData,
  };
};
